/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common (C) Copyright IBM Corp. 2017, 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React, { Component } from 'react';

function propsEqual(nextProps, prevProps) {
	const nextKeys = Object.keys(nextProps);
	const prevKeys = Object.keys(prevProps);

	return (
		nextKeys.length === prevKeys.length &&
		nextKeys.every(key => {
			if (key === 'children') {
				const newChildren = React.Children.toArray(nextProps[key]);
				const oldChildren = React.Children.toArray(prevProps[key]);

				return (
					newChildren.length === oldChildren.length &&
					newChildren.every((child, i) => {
						const oldChild = oldChildren[i];

						return (
							child === oldChild ||
							(child &&
								typeof child === 'object' &&
								oldChild &&
								typeof oldChild === 'object' &&
								oldChild.key === child.key &&
								oldChild.type === child.type &&
								propsEqual(child.props, oldChild.props))
						);
					})
				);
			}

			return nextProps[key] === prevProps[key];
		})
	);
}

export default function pureImmediateProps(WrappedComponent) {
	return class PureImmediatePropsComponent extends Component<any, any> {
		shouldComponentUpdate(nextProps) {
			return !propsEqual(nextProps, this.props);
		}

		static WrappedComponent = WrappedComponent;

		render() {
			return <WrappedComponent {...this.props} />;
		}
	};
}
